<template lang="pug">
  .course
    MainAsideRight(
      :isOpen="isOpen"
      :asideCanSave="canSave"
      storePath="coursesCourse")
      Aside

    .course__block
      .course__header
        p.course__header-amount
          | Все уроки (
          span.ajax__line.courses__ajax.courses__ajax_s.width-15px(v-if="gettingCourse")
          span(v-else) {{lessons.length}}
          | )

        template(v-if="$permissionsCreate")
          .course__header-controls
            //Button.-xs-
              | Настройки курса
            Button.-xs-(@click="addCourse")
              | Добавить урок
        .course__header-end(v-else)
          //- UiButton.course__header-button(
          //-   v-if="isComplete && !gettingCourse"
          //-   :to="`/courses/course/${this.$route.params.courseId}/points_shop`"
          //- )
          //-   | Потратить бонусы
          ProgressBar(:lineWidth="progressBar")

      .course__content
        UiButton.important-button.-telegram-.-mobile-(
          v-if="showTelegram"
          to="/questionnaire/telegram"
        )
          .important-button__content
            Icon(icon="telegram")
            span Подключиться к Telegram боту
        template(v-if="gettingCourse")
          SkeletLesson( :isAdmin="isAdmin")
        template(v-else)
          transition-group.course__list(tag="ul" name="list")
            li.course__item(
              v-for="(lesson, idx) in lessons"
              :key="lesson.id"
            )
              Lesson(
                :lesson="lesson"
                :idx="idx"
                :firstLesson="idx === 0"
                :lastLesson="idx === lessons.length - 1"
                :lessonsLength="lessons.length"
              )
      SuccessFacultyModal

</template>

<script>
import SkeletLesson from './layouts/SkeletLesson';
import Lesson from './layouts/Lesson';
import Aside from './layouts/Aside';
import MainAsideRight from '@/components/MainAsideRight';
import ProgressBar from '@/components/ProgressBar';
import SuccessFacultyModal from '@/views/Courses/components/SuccessFacultyModal';
import { mapActions, mapState } from 'vuex';

export default {
  components: {
    SkeletLesson,
    Lesson,
    MainAsideRight,
    Aside,
    ProgressBar,
    SuccessFacultyModal
  },
  computed: {
    ...mapState('coursesCourse', {
      course: s => s.data.course,
      folder: s => s.data.folder,
      lessons: s => s.data.lessons,
      progressBar: s => s.data.progressBar,
      canSave: s => s.aside.meta.canSave,
      isOpen: s => s.aside.meta.isOpen,
      gettingCourse: s => s.meta.gettingCourse,
      isComplete: s => s.data.course.isComplete
    }),
    ...mapState('auth', {
      $permissions: s => s.data.user.permissions.lessonModuleAdmin,
      isAdmin: s => s.data.user.permissions.isAdmin,
      user: s => s.data.user
    }),
    showTelegram() {
      return this.user.needTelegram && !this.user.redirectToQuestionnaire;
    }
  },
  watch: {
    isErrorCourses(val) {
      if (val) {
        this.$router.push({ path: '/courses/folder/list' });
      }
    },
    $permissionsRead(val) {
      if (!val) {
        this.toPrev();
      }
    },
    course(course) {
      if (course.name) {
        this.$store.dispatch('lms/setMultipleData', [
          { path: 'headerTitle', value: `Курс: ${course.name}` },
          {
            path: 'headerPrevLink',
            value: this.folder.id
              ? '/courses/folder/' + this.folder.id
              : '/courses/folder/list'
          }
        ]);
      }
    }
  },
  beforeMount() {
    if (this.isErrorCourses) {
      this.$router.push({ path: '/courses/folder/list' });
      this.$destroy();
    }
  },
  mounted() {
    this.getCourse({ courseId: this.$route.params.courseId });
    if (!this.isAdmin) {
      this.getCourseStats(this.$route.params.courseId);
    }
  },
  destroyed() {
    this.destroyPoints();
  },
  methods: {
    ...mapActions('coursesCourse', [
      'getCourse',
      'setAsideMeta',
      'getCourseStats',
      'destroyPoints'
    ]),
    toPrev() {
      this.$router.push({
        path: this.folder.id
          ? '/courses/folder/' + this.folder.id
          : '/courses/folder/list'
      });
    },
    addCourse() {
      this.setAsideMeta({ path: 'isOpen', value: true });
    }
  }
};
</script>
